import type { QueryClient } from '@tanstack/react-query';
import type { RouteObject } from 'react-router';

import { productDetailLoader } from '../data-access';
import { AddMultiWeightPrompt } from '../pages/AddMultiWeightPrompt/AddMultiWeightPrompt';

export const multiWeightPromptRoute = (
  queryClient: QueryClient,
  routeId?: string
): RouteObject => ({
  element: <AddMultiWeightPrompt />,
  id: routeId,
  loader: productDetailLoader(queryClient),
  path: `select-addon-weight/:productId`,
});
